import i18n from '@/i18n';

/**
 * User prize payout shape — matches leaderboard / pickem `user_prize` API.
 */
export interface UserPrizeData {
  cash: number | null;
  crowns: number | null;
  other: string | null;
  status?: string;
}

/**
 * Circus Daily Figma prize label — cash as €, else other, else crowns.
 * Shared by leaderboard rows and game-card “My Prize”.
 */
export function formatPrizeLabel(prize?: UserPrizeData | null): string | null {
  if (!prize) return null;
  if (prize.cash && prize.cash > 0) return `€${prize.cash.toLocaleString()}`;
  if (prize.other) return prize.other;
  if (prize.crowns && prize.crowns > 0)
    return `${prize.crowns.toLocaleString()}${i18n.t('prize.crownsSuffix')}`;
  return null;
}
